// Protected Route Component
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, setShowAuthModal } = useAuth();
  const location = useLocation();

  // When an unauthenticated user hits a protected route:
  // store the intended destination then open the auth modal so they
  // land on the right page after signing in (rather than silently going home).
  useEffect(() => {
    if (!loading && !user) {
      localStorage.setItem(
        'finncal_preAuthState',
        JSON.stringify({
          returnPath: location.pathname + location.search,
          pendingSave: false,
          timestamp: Date.now(),
        })
      );
      setShowAuthModal(true);
    }
  }, [loading, user, location, setShowAuthModal]);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
        }}
      >
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {children}
    </>
  );
};

export default ProtectedRoute;
